import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons/faCircleNotch';
import { SpinnerModule } from '../../common/spinner/spinner.module';
import { UiCustomSwitchComponent } from './ui-custom-switch.component';

@NgModule({
	declarations: [
		UiCustomSwitchComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		FontAwesomeModule,
		SpinnerModule
	],
	exports: [
		UiCustomSwitchComponent
	]
})
export class UiCustomSwitchModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faCircleNotch);
	}
}
